import type { TypedHHotelPriceInfo } from './-HHotelPriceInfo';
import RawHHotelPriceInfo from './HHotelPriceInfo.vue';
export * from './-HHotelPriceInfo';
export const HHotelPriceInfo = RawHHotelPriceInfo as typeof TypedHHotelPriceInfo;
